import { Expose } from 'class-transformer';

export class ProductOptionModel {
  @Expose({ name: 'option_id' })
  optionId: number;

  @Expose()
  name: string;

  @Expose()
  description?: string;

  @Expose()
  image?: string;

  @Expose()
  quantity?: number;

  @Expose()
  price?: number;

  @Expose()
  kcal?: number;

  @Expose()
  proteins?: number;

  @Expose()
  fats?: number;

  @Expose()
  carbohydrates?: number;
}
